import * as Statics from '@shared/core/statics';

export class LocationMoreInfoModels {
    private _config: OLO.Config = new Statics.ConfigStatic().current;
    private _configAdditionalInfoFields: OLO.Config.LocationsMoreInfoModalAdditionalFields = this._config.locationMoreInfoModal.additionalInfoFields;
    private _additionalInfoFields: Array<OLO.Common.LocationsMoreInfoModalAdditionalFields> = [];

    constructor(private _location: OLO.DTO.LocationBusinessModel) {}

    public getAdditionalInfoFields(): Array<OLO.Common.LocationsMoreInfoModalAdditionalFields> {
        this._addPhone();
        this._addEmail();

        return this._additionalInfoFields;
    }

    private _addEmail(): void {
        if (this._configAdditionalInfoFields.email && this._location.LocationEmail) {
            this._additionalInfoFields.push({ key: 'email', value: this._location.LocationEmail, icon: 'email' });
        }
    }

    private _addPhone(): void {
        if (this._configAdditionalInfoFields.phone && this._location.LocationPhone) {
            this._additionalInfoFields.push({ key: 'phone', value: this._location.LocationPhone, icon: 'phone' });
        }
    }
}
